const baseUrl = process.env.REACT_APP_API_URL;

const fetchPublic = ( endpoint, data, method = 'GET' ) => {

    const url = `${ baseUrl}/${endpoint}`;

    if (method === 'GET') {
        return fetch(url);
    }else{
        return fetch(url, {
            method,
            headers: {
                'Content-type' : 'application/json'
            },
            body: JSON.stringify(data)
        });
    }
}


const fetchAuth = ( endpoint, data, method = 'GET' ) => {

    const url = `${ baseUrl}/${endpoint}`;


    if (method === 'GET') {
        return fetch(url, {
            method,
            headers: {
                'Authorization' : `Bearer ${localStorage.getItem('token') || ''}`,
            }
        });
    }else{
        return fetch(url, {
            method,
            headers: {
                'Content-type' : 'application/json',
                'Authorization' : `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: JSON.stringify(data)
        });
    }
}

export {
    fetchPublic,
    fetchAuth
}